import React from "react";
import useGoToPricing from "../../hooks/useGoToPricing";
import { isLoggedIn } from "../../utils/isLoggedIn";
import Header from "../Homepage/sections/Header";
import Footer from "../Homepage/sections/Footer";
import { HomepageGlobalStyles } from "../Homepage/styles";
import AlertsCore from "./AlertsCore";
import {
  AlertsPage,
  AlertsHero,
  AlertsHeroBgGradient,
  AlertsHeroBgRadial,
  AlertsHeroInner,
  AlertsHeroTitle,
  AlertsHeroLead,
  AlertsCoreSlot,
  AlertsCta,
  AlertsCtaBg,
  AlertsCtaInner,
  AlertsCtaTitle,
  AlertsCtaLead,
  AlertsCtaButton,
} from "./Alerts.styles";

/**
 * Lovable shell for Alerts. All prod behavior lives in AlertsCore
 * (API, topic/analyst filters, infinite scroll, gating, publish, track/favorite/share, threads).
 */
const Alerts = () => {
  const goToPricing = useGoToPricing();
  const loggedIn = isLoggedIn();

  return (
    <AlertsPage>
      <HomepageGlobalStyles />
      <Header onSubscribeClick={goToPricing} hideSpacer />

      <AlertsHero>
        <AlertsHeroBgGradient aria-hidden="true" />
        <AlertsHeroBgRadial aria-hidden="true" />
        <AlertsHeroInner>
          <AlertsHeroTitle>
            Real-Time <span>Analyst Alerts</span>
          </AlertsHeroTitle>
          <AlertsHeroLead>
            Short-form calls, chart drops, and live market notes from all seven
            analysts as the market moves.
          </AlertsHeroLead>
        </AlertsHeroInner>
      </AlertsHero>

      <AlertsCoreSlot>
        <AlertsCore />
      </AlertsCoreSlot>

      {!loggedIn && (
        <AlertsCta>
          <AlertsCtaBg aria-hidden="true" />
          <AlertsCtaInner>
            <AlertsCtaTitle>
              Never miss a <span>market move</span>
            </AlertsCtaTitle>
            <AlertsCtaLead>
              Members get every alert in real time, plus the full video archive
              from all seven analysts.
            </AlertsCtaLead>
            <AlertsCtaButton type="button" onClick={goToPricing}>
              Start Your Subscription
            </AlertsCtaButton>
          </AlertsCtaInner>
        </AlertsCta>
      )}

      <Footer onSubscribeClick={goToPricing} hideSubscribeCta={loggedIn} />
    </AlertsPage>
  );
};

export default Alerts;
